const NON_CODE_VALUE_REGEX = /[a-zA-Z\u00C0-\u024F]/;

function cleanText(value) {
  if (value == null) return '';
  return String(value).trim();
}

function looksLikeCode(value) {
  const v = cleanText(value);
  if (!v) return true;

  // Reject short uppercase-ish tokens like "DE", "US", "NW", etc.
  if (/^[A-Z0-9-]{1,4}$/.test(v)) return true;

  // Require at least one letter so pure numeric IDs/postcodes are excluded.
  if (!NON_CODE_VALUE_REGEX.test(v)) return true;

  return false;
}

function firstNonCode(address = {}, keys = []) {
  for (const key of keys) {
    const value = cleanText(address?.[key]);
    if (!value) continue;
    if (looksLikeCode(value)) continue;
    return value;
  }
  return '';
}

export function extractTopicGeoContext(locationData) {
  const address = locationData?.address || {};

  const country = firstNonCode(address, ['country']);

  // "Second most zoomed out" under country: prefer state/region-like buckets first.
  const secondMostZoomedOutFeature = firstNonCode(address, [
    'state',
    'region',
    'province',
    'state_district',
    'county',
    'municipality',
    'city',
    'town',
    'village',
    'hamlet',
    'suburb',
    'neighbourhood',
  ]);

  return {
    country,
    secondMostZoomedOutFeature,
  };
}

export function attachTopicGeoContext(locationData) {
  if (!locationData) return locationData;

  const { country, secondMostZoomedOutFeature } = extractTopicGeoContext(locationData);

  return {
    ...locationData,
    topic_country: country || '',
    topic_second_most_zoomed_out_feature: secondMostZoomedOutFeature || '',
  };
}
